import { useInitSdk } from 'hooks/pos'
import { useEffect } from 'react'
import { order as squareOrderApi, SDKAction } from '@squareup/sq-addons-web-sdk'
import { loyaltyApi } from 'api'
import { getOrderCustomer } from 'utils/customer'

const PostPaymentSlot = () => {
  const { initializeSdk } = useInitSdk()
  const [finalizeCheck] = loyaltyApi().useFinalizeCheckMutation()

  useEffect(() => {
    async function registerPurchase() {
      const [order, customer] = await Promise.all([
        squareOrderApi.retrieve(),
        getOrderCustomer(),
      ])

      await finalizeCheck({
        order,
        user_identifier: customer?.referenceId,
      })
    }

    async function init() {
      await initializeSdk({
        [SDKAction.DEVICE_GET_RECEIPTS]: async () => {
          await registerPurchase()
          // TODO: Populate the receipt text and Square know when ready.
          // Square needs to enable a feature flag to show third-party
          // receipt data on Square receipts.
          return {
            digital: {
              title: '',
              body: '',
              url: '',
              urlText: '',
            },
            printed: {
              title: '',
              body: '',
              url: '',
              urlText: '',
            },
          }
        },
      })
    }

    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>
}

export default PostPaymentSlot
